import { useState } from 'react';
import styles from './AddFolder.module.css';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';
import { FaFileAlt } from 'react-icons/fa';

const AddFolder = () => {
  const [folderName, setFolderName] = useState('');
  const dispatch = useDispatch();

  const handleSave = () => {
    if (folderName.trim()) {
      console.log('Folder Created:', folderName);
      dispatch(closeModal());
    } else {
      alert('Please enter a folder name.');
    }
  };
  const handleClose = () => {
    dispatch(closeModal());
  };
  const handleCancel = () => {
    setFolderName('');
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<FaFileAlt />}
          heading="Add Folder"
          color={'var(--Primary_Color)'}
        />
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.body}>
        <HeadingAndData
          label="Folder Name"
          name="folderName"
          placeholder="Enter Folder name"
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          required
        />

        <div className={styles.actions}>
          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default AddFolder;
